import React, {useEffect} from "react";
 
import { useHistory } from "react-router-dom";
import URLS from "../../../config/navigation";
import CircularProgress from "@material-ui/core/CircularProgress";
import {confirmStripeAccountToken} from "../../../store/entities/App/App.actions";
import {useDispatch} from "react-redux";
import queryString from "query-string";

const delay = ms => new Promise(res => setTimeout(res, ms));

const AccountConnect = (props) => {
 
  const history = useHistory();
  const dispatch = useDispatch();

  const callback = () => {
    history.push(URLS.PUBLIC.FINISH_SETTINGS_ACC);
  }

  useEffect( async () => {
    const { code } = queryString.parse(props.location.search);
    dispatch(confirmStripeAccountToken({ token: code, callback }));
    // await delay(2000);
    // history.push(URLS.PUBLIC.FINISH_SETTINGS_ACC);
  }, [])

  return (
    <div className={"statusContainer"}>
      <CircularProgress className="loader" />
      <h1 className={"title H1"}>
         Connecting your bank account…
      </h1>
     
    </div>
  );
}

export default AccountConnect;
